import FavouriteProduct from '../../components/favourite-product';

export default class Favourites {
  constructor(){
    this.favourite = new FavouriteProduct();
  }
}